<!--  -->
<template>
  <div class="CrumbsNav">
    <div class="crumbs">
      <span>{{ place }}：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbsnav">
        <el-breadcrumb-item
          :to="{ path: el.url }"
          v-for="(el, key) in crumbsnav"
          :key="key"
          >{{ el.title }}</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      place: "", //您的位置
      // crumbsnav: [
      //   // {
      //   //   title: "首页",
      //   //   url: "/index",
      //   // },
      //   // {
      //   //   title: "关于堃博",
      //   //   url: "/aboutUs*",
      //   // },
      // ],
    };
  },
  props: {
    crumbsnav: {
      type: null, // 定义接收到的数据的类型
      required: false, //规定这个数据是否必传,默认false
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //面包屑
    get_mianbao() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "get_all_nav_parent",
          nid: 2,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.crumbsnav;
            $.each(obj.data, function (i, k) {
              that.crumbsnav.push({
                title: k.title,
                url: k.url,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.place = obj.data["ndwz"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_mianbao();
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.CrumbsNav {
  width: 100%;
  height: 70px;
  .crumbs {
    width: $main-width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    span {
      color: #999;
      font-size: 1rem;
      line-height: 1;
    }
    .crumbsnav {
      font-size: 1rem;
      font-weight: 400;
      color: #333333;
      margin-left: 10px;
    }
    .el-breadcrumb__item:last-child /deep/ .el-breadcrumb__inner {
      color: #999 !important;
    }

    .el-breadcrumb /deep/ .el-breadcrumb__inner {
      color: #999 !important;
      font-weight: 400 !important;
    }

    .el-breadcrumb__item /deep/ .el-breadcrumb__inner:hover {
      color: #333 !important;
    }
  }
}
@media screen and (max-width: $main-width) {
  .CrumbsNav {
    height: 50px;
    .crumbs {
      width: 100%;
      padding: 0 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CrumbsNav.vue